import { useIdleTimer } from 'react-idle-timer';
import Auth from '@/utils/api/odas/auth';

export default function useReAuth(timerOptions) {
  const defaultOptions = { timeout: 1000 * 60 * 20, disable: false };

  const timeout = timerOptions?.timeout || defaultOptions.timeout;
  const disable = timerOptions?.disable || defaultOptions.disable;

  const onIdle = (disabled) => {
    if (disabled) {
      return;
    }
    if (Auth.isLoggedIn() && !Auth.sessionIsExpired) {
      Auth.expireSession();
      window.location.href = Auth.getUrlFor('confirm-login');
    }
  };
  return useIdleTimer({
    onIdle: () => onIdle(disable),
    timeout: timeout
  });
}
